<template>
  <portal to="modal" v-if="show">
    <div
      class="fixed inset-x-0 top-0 bottom-0 z-50 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
      style="background-color: rgba(82, 95, 127, 0.5);"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <div :class="modalClass" class="transition-all transform bg-white rounded-lg shadow-xl sm:max-w-xl  sm:w-full">
        <slot></slot>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    show: { required: true },
    modalClass:{required: false, default:'', type: String},
    preventBackgroundScrolling: { default: true }
  },
  methods: {
    dismiss() {
      this.$emit("close");
    }
  },
  destroyed() {
    document.body.style.removeProperty("overflow");
  },
  watch: {
    show: {
      immediate: true,
      handler: function(show) {
        if (show) {
          this.preventBackgroundScrolling &&
            document.body.style.setProperty("overflow", "hidden");
        } else {
          this.preventBackgroundScrolling &&
            document.body.style.removeProperty("overflow");
        }
      }
    }
  },
  created() {
    const escapeHandler = e => {
      if (e.key === "Escape" && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener("keydown", escapeHandler);

    this.$once("hook:destroyed", () => {
      document.removeEventListener("keydown", escapeHandler);
    });
  }
};
</script>